import { render } from "./HeaderLayout.vue?vue&type=template&id=5cd164d8&ts=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=ts"
export * from "./HeaderLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__